import React from "react";
import FeatureCard from "../FeatureCard";

export default () => (
  <FeatureCard
    to="/partnership/tiers"
    image="/static/img/Card-PartnershipTiers.png"
    imageAlt="Partners shaking hands"
    description="Discover our Partnership Tiers"
  >
    Explore what the different tiers of partnership with Skyward mean. Learn how your company can earn its next badge!
  </FeatureCard>
);
